import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OktaFlowService } from './okta-flow.service';
import { WindowService } from '@cigna/shared/angular/core/window-util';

@Injectable()
export class OktaDeepLinkGuard {
  constructor(
    private _window: WindowService,
    private _authenticator: OktaFlowService,
    private _router: Router,
    @Inject(APP_BASE_HREF) private _baseHref: string,
  ) {}

  canActivate() {
    const deepLink = this._authenticator.getOriginalUri() || this._baseHref;
    this._authenticator.setOriginalUri('');
    if (
      deepLink.startsWith(this._baseHref) ||
      deepLink === '/' ||
      deepLink.startsWith('/?')
    ) {
      const route = deepLink.replace(this._baseHref, '').replace(/\/$/, '');
      const parsed = this._router.parseUrl(route);
      return this._router.navigateByUrl(parsed);
    }
    this._window.location.assign(deepLink);
    return false;
  }
}
